// eslint-ignore
export default 
`<DtTabs :tabList="tabsCount">
  <template v-slot:tabPanel-1> Content 1 </template>
  <template v-slot:tabPanel-2> Content 2 </template>
  <template v-slot:tabPanel-3> Content 3 </template>
  <template v-slot:tabPanel-4> Content 4 </template>
</DtTabs>

export default {
  data () {
    return {
      tabsCount: [
        { text: 'Tab with Count 1', count: '23'},
        { text: 'Tab with Count 2', count: '5'},
        { text: 'Tab with Count 3', count: '17'},
        { text: 'Tab with Count 4', count: '0'}
      ],
    }
  }
}`;